module.exports = __webpack_public_path__ + "images/9b418aac11a5585c20139498297d78f5.png";